import { Component, OnInit } from '@angular/core';
import BaseDetailPageConfig from '../../../../models/base-detail-page.config';
import { BaseDetailPageComponent } from '../../../../components/pages/base-detail-page/base-detail-page.component';
import { RouteService } from '../../../../services/route.service';
import { SpecialisationsService } from 'src/app/services/api/hr/specialisations.service';

@Component({
  selector: 'app-specialisation-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './specialisation-detail-page.component.html',
  styleUrl: './specialisation-detail-page.component.scss'
})
export class SpecialisationDetailPageComponent implements OnInit {
  baseDetailPageConfig!: BaseDetailPageConfig;
  readonlyUserDetail: boolean;

  specialisation?: any;

  constructor(
    private specialisationsService: SpecialisationsService,
    private routeService: RouteService
  ) {
    this.readonlyUserDetail = true;
  }

  ngOnInit(): void {
    this.baseDetailPageConfig = {
      pageTitle: 'Specialisation Details',
      cardTitle: 'View Specialisation',
      editItemButton: {
        type: 'primary',
        title: 'Update',
        onClick: () => {
          this.routeService.specialisationUpdate(this.specialisation.employeeSpecialisationId)
        }
      },
      dataList: {
        data:null,
        rows: [
           {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => {
              return item.code;
            }
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => {
              return item.name;
            }
          },
        ]
      },
      apiDetailService: (employeeSpecialisationId: number) => this.specialisationsService.detail(employeeSpecialisationId),
      routeParamName: 'employeeSpecialisationId',
      responseModelName: 'employeeSpecialisation'
    };
  }

  onLoadedDetail(data: any) {
    this.specialisation = data;
  }
}
